import { get } from 'lodash';

import { statusCodes } from '../foundations/theme';

export const getColourSchemeBasedOnStatus = (status?: string) => get(statusCodes, status ?? '')?.base || statusCodes.default.base;

export const getLightStatusColor = (status?: string) => get(statusCodes, status ?? '')?.light || statusCodes.default.light;

export const getMediumStatusColor = (status?: string) => get(statusCodes, status ?? '')?.medium || statusCodes.default.medium;

export const getDarkStatusColor = (status?: string) => get(statusCodes, status ?? '')?.dark || statusCodes.default.dark;

export const getTextStatusColor = (status?: string) => get(statusCodes, status ?? '')?.text || statusCodes.default.text;

export default getColourSchemeBasedOnStatus;
